export const headerColumns = [
  {
    id: 0,
    name: '',
    width: '41px'
  },
  {
    id: 1,
    name: 'Дата',
    width: '110px'
  },
  {
    id: 2,
    name: 'Канал',
    width: '80px'
  },
  {
    id: 3,
    name: 'Опубликованно отзывов 1*-3* за период',
    width: '180px'
  },
  {
    id: 4,
    name: 'Всего',
    width: '220px'
  },
  {
    id: 5,
    name: 'Снято отзывов 1*-3* за период',
    width: '180px'
  },
  {
    id: 6,
    name: 'Всего',
    width: '220px'
  },
  {
    id: 7,
    name: '% закрытия негатива (снято к опубликовано, %)',
    width: '340px'
  }
]
